'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var callBind = require('call-bind');

var callBound = require('call-bind/callBound');

var GetIntrinsic = require('get-intrinsic');

var isTypedArray = require('is-typed-array');

var $ArrayBuffer = GetIntrinsic('ArrayBuffer', true);
var $Float32Array = GetIntrinsic('Float32Array', true);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true); // in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method

var abSlice = $ArrayBuffer && !$byteLength && new $ArrayBuffer().slice;
var $abSlice = abSlice && callBind(abSlice);
module.exports = $byteLength || $abSlice ? function isArrayBuffer(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }

  try {
    if ($byteLength) {
      $byteLength(obj);
    } else {
      $abSlice(obj, 0);
    }

    return true;
  } catch (e) {
    return false;
  }
} : $Float32Array // in node 0.8, ArrayBuffers have no prototype or own methods
? function IsArrayBuffer(obj) {
  try {
    return new $Float32Array(obj).buffer === obj && !isTypedArray(obj);
  } catch (e) {
    return _typeof(obj) === 'object' && e.name === 'RangeError';
  }
} : function isArrayBuffer(obj) {
  // eslint-disable-line no-unused-vars
  return false;
};